import {
  LazyQueryExecFunction,
  OperationVariables,
  useLazyQuery
} from '@apollo/client'
import {
  ButtonBase,
  Grow,
  Modal,
  Paper,
  Slide,
  Typography
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import DateRangeIcon from '@material-ui/icons/DateRange'
import FilterListIcon from '@material-ui/icons/FilterList'
import { FC, useEffect, useMemo, useState } from 'react'

import { DateRangePicker } from '../../../components/DatePicker/DateRangePicker'
import { ROOMTYPES_QUERY } from '../../../graphql/roomtype'
import { DateObject, getDatesList } from '../../../helpers/date'
import { getDirection, getTranslate, lang } from '../../../localization'
import { LocalizedLink } from '../../../routes/localizedRoutes'
import {
  AllocatedData,
  RoomtypeForAllocatedList
} from '../../../types/inventoryAllocatedList'
import { RoomTypeBrief } from '../../../types/roomtype'
import FilterModal from './FilterModal'
import InventoryDateRow from './InventoryDateRowMobile'
import InventoryTableRatePlan from './InventoryTableRatePlan'
import InventoryTableRoomType from './InventoryTableRoomType'
import ChannelTitle from './RateplanTitle'
import useStyles from './styles/index.styles'

interface InventoryMobileProps {
  selectedAccommodation: any
  setselectedAccommodation: React.Dispatch<
    React.SetStateAction<
      | {
          label: string
          value: string
          code: string
        }
      | undefined
    >
  >
  selectedRoomTypeCode: any
  setselectedRoomTypeCode: (v: {
    label: string
    value: string
    code: string
  }) => void
  selectedChannel: any
  setselectedChannel: (v: {
    label: string
    value: string
    code: string
  }) => void
  selectedDateInDatePicker: DateObject
  setselectedDateInDatePicker: React.Dispatch<React.SetStateAction<DateObject>>
  roomtypesForAllocatedData: RoomtypeForAllocatedList[]
  weekendIndexes: number[]
  getAllocatedList: LazyQueryExecFunction<
    {
      allocatedList: AllocatedData
    },
    OperationVariables
  >
}

const AllocateMobile: FC<InventoryMobileProps> = ({
  roomtypesForAllocatedData,
  selectedAccommodation,
  selectedChannel,
  selectedDateInDatePicker,
  selectedRoomTypeCode,
  setselectedAccommodation,
  setselectedChannel,
  setselectedDateInDatePicker,
  setselectedRoomTypeCode,
  getAllocatedList
}) => {
  const classes = useStyles()
  const [datePickerOpen, setdatePickerOpen] = useState<boolean>(false)

  const [filtersOpen, setfiltersOpen] = useState<boolean>(false)
  const [showChannels, setshowChannels] = useState<boolean>(false)

  const [getRoomTypes, { data: roomtypes, loading: loadingForRoomtypes }] =
    useLazyQuery<{
      roomTypes: RoomTypeBrief[]
    }>(ROOMTYPES_QUERY)
  useEffect(() => {
    if (showChannels && selectedAccommodation) {
      getRoomTypes({
        variables: {
          propertyCode: selectedAccommodation.code,
          showDeletedRoomTypes: false,
          showDeactivedRoomTypes: false
        }
      })
    }
  }, [showChannels, selectedAccommodation])
  const datesList = useMemo(
    () => getDatesList(14, selectedDateInDatePicker.gregorianStartDate),
    [selectedDateInDatePicker.gregorianStartDate]
  )

  return (
    <div>
      <div className={classes.buttonContainer}>
        <ButtonBase
          component={LocalizedLink}
          to={'/allocate-availability/allocate-to-channel'}>
          <Typography variant="body1">
            {getTranslate('Allocate to channel')}
          </Typography>
          <AddIcon />
        </ButtonBase>
      </div>
      <div
        className={[
          classes.filtersButton,

          classes.filtersButtonForOneButtonOnly
        ].join(' ')}>
        <ButtonBase
          className={classes.filterButton}
          onClick={() => setfiltersOpen(true)}>
          <Typography variant="body1">{getTranslate('Filter')}</Typography>
          <div>
            <FilterListIcon />
          </div>
        </ButtonBase>
      </div>
      <div className={classes.dateButtonContainer}>
        <ButtonBase
          className={classes.dateButton}
          onClick={() => {
            setdatePickerOpen(true)
          }}>
          <Typography variant="body1">{getTranslate('Date')}</Typography>
          <div>
            <DateRangeIcon />
          </div>
        </ButtonBase>
      </div>

      <div className={classes.tableContainer}>
        <div className={classes.tableTitles}>
          <div className={classes.bigDateContainer}>
            <Typography
              variant="h3"
              color="primary"
              className={classes.bigDate}>
              {lang === 'en'
                ? datesList[0].gregorianDate.year
                : datesList[0].jalaaliDate.year}
            </Typography>
          </div>
          {selectedRoomTypeCode && selectedRoomTypeCode.value ? (
            <div
              className={classes.rowNameContainer}
              onClick={() => {
                if (!loadingForRoomtypes) {
                  setshowChannels(false)
                  setselectedRoomTypeCode({
                    value: '',
                    label: '',
                    code: ''
                  })
                }
              }}>
              <Typography variant="h4" className={classes.rowName}>
                {
                  roomtypesForAllocatedData.find(
                    (roomtype) =>
                      roomtype.basicDetails.roomtypeCode ===
                      selectedRoomTypeCode.code
                  )?.basicDetails.name
                }
              </Typography>

              <ArrowRightIcon
                className={[classes.channelArrowRight].join(' ')}
              />
            </div>
          ) : (
            roomtypesForAllocatedData.map((roomtype) => (
              <div
                className={classes.rowNameContainer}
                onClick={() => {
                  if (!loadingForRoomtypes) {
                    setshowChannels(true)

                    setselectedRoomTypeCode({
                      label: roomtype.basicDetails.name,
                      value:
                        roomtypes?.roomTypes.find(
                          (rt) =>
                            rt.displayRoomTypeCode ===
                            roomtype.basicDetails.roomtypeCode
                        )?.id || '',
                      code: roomtype.basicDetails.roomtypeCode
                    })
                  }
                }}>
                <Typography variant="h4" className={classes.rowName}>
                  {roomtype.basicDetails.name}
                </Typography>

                <ArrowRightIcon
                  className={[classes.channelArrowRight].join(' ')}
                />
              </div>
            ))
          )}
          {!loadingForRoomtypes &&
            showChannels &&
            roomtypesForAllocatedData
              .find(
                (roomtype) =>
                  roomtype.basicDetails.roomtypeCode ===
                  selectedRoomTypeCode.code
              )
              ?.channels.map((channelItem) => (
                <ChannelTitle channelItem={channelItem} />
              ))}
        </div>
        <div className={classes.tableContent}>
          <InventoryDateRow
            {...{ selectedDateInDatePicker, setselectedDateInDatePicker }}
            range={'TWO_WEEKS'}
          />
          <InventoryTableRoomType
            roomtypes={roomtypesForAllocatedData}
            selectedRoomTypeCode={selectedRoomTypeCode}
          />
          {!loadingForRoomtypes &&
            showChannels &&
            roomtypesForAllocatedData
              .find(
                (roomtype) =>
                  roomtype.basicDetails.roomtypeCode ===
                  selectedRoomTypeCode.code
              )
              ?.channels.map((channelItem) => (
                <InventoryTableRatePlan channelData={channelItem} />
              ))}
        </div>
      </div>
      <Modal
        open={filtersOpen}
        dir={getDirection()}
        className={classes.filterForMobileSizeModal}
        onClose={() => setfiltersOpen(false)}>
        <Slide in={filtersOpen} direction="up" timeout={300}>
          <Paper className={classes.filterForMobileSize}>
            <FilterModal
              setFilterButtonSelected={setfiltersOpen}
              setselectedAccommodation={setselectedAccommodation}
              selectedAccommodation={selectedAccommodation}
              selectedRoomTypeCode={selectedRoomTypeCode}
              setselectedRoomTypeCode={setselectedRoomTypeCode}
              selectedChannel={selectedChannel}
              setselectedChannel={setselectedChannel}
              dateObject={selectedDateInDatePicker}
              getAllocatedList={getAllocatedList}
            />
          </Paper>
        </Slide>
      </Modal>

      {datePickerOpen && (
        <Grow in>
          <DateRangePicker
            onChange={(data: DateObject) => {
              setselectedDateInDatePicker(data)
            }}
            type={lang === 'fa' ? 'jalaali' : 'gregorian'}
            dateObject={selectedDateInDatePicker}
            onDoneClicked={() => setdatePickerOpen(false)}
            autoSelectedEndDate
            numberOfHoveredItems={14}
          />
        </Grow>
      )}
    </div>
  )
}
export default AllocateMobile
